import { Component, inject, OnInit, DOCUMENT } from '@angular/core';
import { environment } from "src/environments/environment";
import { RouterOutlet } from '@angular/router';


@Component({
    selector: 'aql-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
    title: string = 'AQuila';
    private readonly document: Document = inject(DOCUMENT);

    ngOnInit(): void {
        if (!environment.production) {
            console.log('Using environment file: ' + environment.environmentFileName);
        }
        this.setFavicon(environment.faviconFile);
        this.adjustTabName();
    }

    private setFavicon(iconPath: string): void {
        let link: HTMLLinkElement | null = this.document.querySelector("link[rel*='icon']") as HTMLLinkElement | null;

        if (!link) {
            link = this.document.createElement('link');
            link.rel = 'icon';
            this.document.head.appendChild(link);
        }

        link.type = 'image/x-icon';
        link.href = iconPath;
    }

    private adjustTabName(): void {
        document.title = `${this.title}${environment.environmentNameSuffix}`;
    }
}
